<template>
  <div id="header" v-on:click="goHome">
    <!-- <router-link :to="{ name: 'Home'}"><img id="title" alt="La mujer cambiante" src="../assets/lamujercambiante-1000.png"></router-link> -->
    <!-- <h2>TRADUCCION EDITORIAL</h2> -->
  </div>
</template>

<script>
export default {
  name: 'Header',
  methods: {
    goHome () {
      if (window.location.pathname !== '/') {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style lang="scss">

.link {
  cursor: pointer;
}

#header {
  cursor: pointer;
  height: 69px;
  max-height: 69px;
  // max-width: 1000px;
  margin-left: 0.5em;
  margin-right: 0.5em;

  padding-left: 1em;
  padding-right: 1em;
  // max-width: 100vh;

  // @if $debug == true {
  //   background-color: beige;
  //   border: solid 1px #00FF00;
  // }

  background: url("../assets/lamujercambiante-1000.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-origin: padding-box;
  color: aliceblue;
  // font-size: 24px;
  font-weight: bold;

  filter: drop-shadow(0px 0px 6px #666666);
}

@include respond-above(lg) {
  #header  {
  margin-top: 3.5em;
    // margin-top: 60px;
  }
}

@include respond-between(md, lg) {
  #header  {
  margin-top: 1.5em;
    // margin-top: 60px;
  }
}

@include respond-below(md) {
  #header  {
  margin-top: 1.05em;

    // margin-top: 60px;
  }
}

</style>
